import { UPDATE_ATTRIBUTE } from "../../constants/reduxActionTypes";

// eslint-disable-next-line import/prefer-default-export
export const updateAttribute = content => ({
  type: UPDATE_ATTRIBUTE,
  payload: {
    ...content
  }
});



// WEBPACK FOOTER //
// ./src/redux/actions/generalActions.js